import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DashboardResponse } from '../../../../api/models/dashboardResponse';
@Component({
    selector: 'qvinactive',
    template: require('./qvdashboardInactive.component.html')
})

export class QVInactiveComponent {

    public ham: boolean = false;

    @Input() dataSearch: DashboardResponse;
    @Input() status: any;
    @Output() placardIdDetail = new EventEmitter<string>();

    constructor() {
        /* empty */
    }

    showHam() {
        this.ham = (this.ham) ? false : true;
    }

    showDetail(placardId: string) {
        if (placardId.length > 0) {
            this.placardIdDetail.emit(placardId);
        }
    }
}